import {useEffect, useState} from "react";
import "../assets/css/style.css"
import loginVector from '../assets/img/chat-img-en.jpg'
import userIcon from '../assets/img/user.png'
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {Link, useSearchParams} from "react-router-dom";
import OtpInput from 'react-otp-input';
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import {Dimmer, Loader} from "semantic-ui-react";
import Dropdown from "react-bootstrap/Dropdown";
import iran from "../assets/img/iran.png";
import english from "../assets/img/english.png";
import rahatSite from "../assets/img/site.webp";
import rahatSabt from "../assets/img/sabt.webp";
import rahatAds from "../assets/img/ads.webp";
import rahatMohtava from "../assets/img/mohtava.webp";

const LoginEn= () => {

    const [height, setHeight] = useState(window.innerHeight);
    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState('');
    const [sellerId, setSellerId] = useState(null);
    const [type, setType] = useState('mobile');
    const [email, setEmail] = useState('');
    const [mobileOtp, setMobileOtp] = useState(true);
    const [emailOtp, setEmailOtp] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [modal, setModal] = useState(false);
    const [codeInput, setCodeInput] = useState(false);
    const [codeInputMobile, setCodeInputMobile] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isDisable, setIsDisable] = useState(false);
    const [searchParams] = useSearchParams();
    const [timer, setTimer] = useState(120); // 2 minutes in seconds
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        let countdown;
        document.title = 'RahatBin Online Chat';
        if (isActive && timer > 0) {
            countdown = setTimeout(() => {
                setTimer(timer - 1);
            }, 1000);
        } else if (timer === 0) {
            setIsActive(false);
            setOtp('')
        }

        return () => clearTimeout(countdown);
    }, [isActive, timer]);

    function startTimer() {
        setIsActive(true);
    }

    function formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }


    const handleResize = () => {
        setHeight(window.innerHeight);
    };

    function checkPhone() {
        const iranianPhoneNumberRegex = /^(09)?\d{8}$/;
        if (phone == '') {
            setShowAlert('Mobile number field is required')
        }
        if (iranianPhoneNumberRegex.test(phone)) {
            setShowAlert(false)
        } else {
            setShowAlert(true)
            setAlertText('The mobile number entered is not valid.')
        }
    }

    function toggle() {
        setModal(!modal)
        setOtp('')
        setIsLoading(true)
    }

    function sendOtp(e) {
        e.preventDefault()
        const data = new FormData();
        if (type === 'mobile') {
            data.append('data', phone)
        } else {
            data.append('data', email)
        }
        data.append('type', type)
        axios.post('https://rahatsite.com/api/send/otp', data)
            .then((res) => {
                if (res.data.success) {
                    startTimer()
                    setIsLoading(true)
                    if (type === 'mobile') {
                        setCodeInputMobile(true)
                        setCodeInput(false)
                    } else {
                        setCodeInput(true)
                        setCodeInputMobile(false)

                    }
                    toast.success('Verification code sent successfully.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                } else {
                    setIsLoading(true)
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            })
            .catch((err) => {
                setPhone('')
                setEmail('')
                setIsLoading(true)
                if (err.response.status === 422) {
                    let errors = [];
                    for (let error in err.response.data.errors)
                        err.response.data.errors[error].forEach((item) =>
                            errors.push(item)
                        );

                    errors.map((item, index) => {
                        toast.error(index + 1 + " - " + item, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });

                    })

                } else {
                    toast.error('Error, try again', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }


            })
    }

    function verifyOtp(e) {
        e.preventDefault()
        const data = new FormData();
        if (type === 'mobile') {
            data.append('data', phone)
        } else {
            data.append('data', email)
        }
        data.append('type', type)
        data.append('code', otp)
        axios.post('https://rahatsite.com/api/verify/otp', data)
            .then((res) => {
                setIsDisable(false)
                if (res.data.success) {

                    if (res.data?.data?.token === null) {
                        if (type === 'mobile'){
                            window.dataLayer.push({ event: 'chatinputmobilecode' });
                        }
                        else {
                            window.dataLayer.push({ event: 'chatinputemailcode' });
                        }
                        window.localStorage.setItem('type', type)
                        if (type === 'mobile') {
                            window.localStorage.setItem('mobile', phone)
                        } else {
                            window.localStorage.setItem('email', email)
                        }

                        if (sellerId !== null) {
                            window.location.href = '/register/en?sellerId=' + sellerId;
                        } else {
                            window.location.replace('/register/en')
                        }
                    }
                    else {
                        window.localStorage.setItem('token', res.data?.data?.token)
                        window.location.replace('/chat/en')
                    }
                } else {
                    setIsLoading(true)
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            })
            .catch((err) => {
                setIsDisable(false)
                setIsLoading(true)
                if (err.response.status === 422) {
                    let errors = [];
                    for (let error in err.response.data.errors)
                        err.response.data.errors[error].forEach((item) =>
                            errors.push(item)
                        );

                    errors.map((item, index) => {
                        toast.error(index + 1 + " - " + item, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });

                    })

                } else {

                    toast.error('Error, try again', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }


            })
    }

    useEffect(() => {
        let id = searchParams.get('sellerId');
        if (id !== null) {
            setSellerId(id)
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>

            {/* Same as */}
            <ToastContainer/>
            <div className="container-fluid login-back"  style={{height: 'fit-content',overflow:'hidden'}}>
                <div className={'row justify-content-start text-center'} style={{height:'fit-content',paddingBottom:'20%'}}>

                    <Modal isOpen={modal} toggle={toggle} backdrop={false} size={'lg'}>
                        <ModalHeader toggle={toggle}
                                     className={'d-flex justify-content-between text-lg-end'}></ModalHeader>
                        <ModalBody className={'px-0 px-md-3 px-lg-5 '}>
                            <Row>
                                <a href={'https://rahatmohtava.com/en'} rel={'nofollow'} target={'_blank'} className={'col-6 col-md-3 text-center  d-grid justify-content-center circle'}>
                                    <img src={rahatMohtava} alt={"RahatMohtava"} width={'80'} height={'80'} title={"RahatMohtava"}/>
                                    <span>RahatMohtava</span>
                                </a>
                                <a href={'https://rahatads.com/en'} rel={'nofollow'} target={'_blank'} className={'col-6 col-md-3 text-center  d-grid justify-content-center circle'}>
                                    <img src={rahatAds} alt={"RahatAds"} width={'80'} height={'80'} title={"RahatAds"}/>
                                    <span>RahatAds</span>
                                </a>
                                <a href={'https://rahatsabt.com/en'} rel={'nofollow'} target={'_blank'} className={'col-6 col-md-3 text-center  d-grid justify-content-center circle'}>
                                    <img src={rahatSabt} alt={"RahatSabt"} width={'80'} height={'80'} title={"RahatSabt"}/>
                                    <span>RahatSabt</span>
                                </a>
                                <a href={'https://rahatsite.com/en'} rel={'nofollow'} target={'_blank'} className={'col-6 col-md-3 text-center d-grid justify-content-center circle'}>
                                    <img src={rahatSite} alt={"RahatSite"} width={'80'} height={'80'} title={"RahatSite"}/>
                                    <span>RahatSite</span>
                                </a>
                            </Row>
                        </ModalBody>
                        <ModalFooter className={'justify-content-center'}>
                            <Button color="danger" onClick={toggle}>Close</Button>
                        </ModalFooter>
                    </Modal>

                    <div className={"col-md-0 col-lg-8 "}>
                        <div className={"row justify-content-center vector"}>
                            <div className={'col-6'} style={{cursor:'pointer'}} onClick={(e)=>{
                                setModal(true)
                            }}>
                                <img src={loginVector} width={600} height={'auto'} alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className={"col-12 col-lg-4 login-box"} style={{height: height + 'px',direction:'ltr'}}>
                        <h4 style={{fontWeight: 800, color: '#FFD02A', fontFamily: 'IRANSans', fontSize: '20px'}}>Welcome to Rahat Bin customer chat panel <span
                                style={{color: '#fff!important'}}>👋</span></h4>

                        <div className="row justify-content-center text-center mt-5">
                            <Dropdown>
                                <Dropdown.Toggle variant="warning"  align={{ lg: 'center' }} id="dropdown-basic" className={'px-5'}>
                                    Language
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="/" style={{direction:'rtl',textAlign:'left'}}>
                                        فارسی <img src={iran} className={'ms-3'} width={30} height={20} alt=""/>
                                    </Dropdown.Item>
                                    <Dropdown.Item href="/en"  style={{direction:'rtl',textAlign:'left'}} >
                                        English <img src={english} className={'ms-3'} width={30} height={20} alt=""/>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                        <div className={"row justify-content-center "}>
                            <div className={'col-12 col-md-10 login-form justify-content-center text-center'}>
                                <img className={'user-icon'} src={userIcon} alt=""/>
                                <h3 style={{fontWeight: 800, fontFamily: 'IRANSans',direction:'ltr'}}>Login / Register</h3>
                                <Row className={'mt-5'}>
                                    <div className={'col-12'}>
                                        <FormGroup className={'d-flex justify-content-center'}>
                                            <Label>
                                                <Input
                                                    type="radio"
                                                    name="option"
                                                    value="mobile"
                                                    checked={type === 'mobile'}
                                                    onChange={() => {
                                                        setMobileOtp(true)
                                                        setEmailOtp(false)
                                                        setType('mobile')
                                                    }}
                                                    style={{marginRight: '7px'}}

                                                />
                                                mobile
                                            </Label>
                                            <br/>
                                            <Label style={{marginLeft: '50px'}}>
                                                <Input
                                                    type="radio"
                                                    name="option"
                                                    value="email"
                                                    checked={type === 'email'}
                                                    onChange={() => {
                                                        setEmailOtp(true)
                                                        setMobileOtp(false)
                                                        setType('email')
                                                    }}
                                                    style={{marginRight: '7px'}}
                                                />
                                                email
                                            </Label>
                                        </FormGroup>
                                    </div>

                                    {mobileOtp &&
                                        <div className={'col-12 text-start mt-3'}>
                                            <FormGroup style={{direction:'ltr'}}>
                                                <Label for="phone">mobile</Label>
                                                <Input style={{fontWeight: 800, fontFamily: 'IRANSans',textAlign:'left',direction:'ltr'}} type="text"
                                                       name="phone" id="phone" inputmode="numeric" pattern="[0-9]*" onChange={(e) => {
                                                    setPhone(e.target.value)
                                                    checkPhone()
                                                }} placeholder="Enter your phone number ..."/>
                                            </FormGroup>
                                            {showAlert && <div
                                                className={'col-12 text-start alert alert-danger p-1'}>{alertText}</div>}
                                            {codeInputMobile && <FormGroup>
                                                <Label for="otpCode">Code</Label>
                                                <Input type="number" style={{fontWeight: 800, fontFamily: 'IRANSans'}}
                                                       name="otp" id="otpCode" onChange={(e) => {
                                                    setOtp(e.target.value)
                                                }} placeholder="Enter otp code ...."/>
                                            </FormGroup>}
                                        </div>
                                    }


                                    {emailOtp &&
                                        <div className={'col-12 text-start mt-3'}>
                                            <FormGroup>
                                                <Label for="exampleEmail">email</Label>
                                                <Input type="email" style={{
                                                    fontWeight: 800,
                                                    fontFamily: 'IRANSans',
                                                    direction: 'ltr'
                                                }}
                                                       name="email" id="exampleEmail" onChange={(e) => {
                                                    setEmail(e.target.value)
                                                }} placeholder="Enter your email ..."/>
                                            </FormGroup>
                                            {codeInput && <FormGroup>
                                                <Label for="otpCode">Code</Label>
                                                <Input type="number" style={{fontWeight: 800, fontFamily: 'IRANSans'}}
                                                       name="otp" id="otpCode" onChange={(e) => {
                                                    setOtp(e.target.value)
                                                }} placeholder="Enter otp code ..."/>
                                            </FormGroup>}

                                        </div>
                                    }


                                </Row>


                            </div>
                            <div className={'col-6'}>
                                {codeInputMobile || codeInput ?

                                    <>
                                        <div className={'row justify-content-around text-center'}>
                                            <div className={'col-6'}>
                                                <span className={'bold text-light'}>  {isActive && formatTime(timer) } </span>

                                            </div>

                                        </div>



                                        <div className={'row justify-content-around text-center'}>
                                            <div className={'col-10'}>
                                                {
                                                    isActive ?
                                                        <Button color="warning" className={'custom-btn1  mt-4 chatinputmobilenumber'} style={{padding:'5px 30px'}}  size={'md'} onClick={(e) => {
                                                            verifyOtp(e)
                                                            setIsDisable(true)
                                                            setIsLoading(false)
                                                        }}
                                                                disabled={otp == '' || otp.length < 4 || isDisable} block>submit</Button> :

                                                        <Button color={'secondary'} className={' mt-4'} size={'md'}
                                                                disabled={(type === 'mobile' && phone === '') || (type === 'email' && email === '') || showAlert || !isLoading}
                                                                onClick={(e) => {
                                                                    setIsLoading(false)
                                                                    setTimer(110);
                                                                    setIsActive(false);
                                                                    sendOtp(e)
                                                                }} block>
                                                           resend code

                                                        </Button>
                                                }
                                            </div>
                                            <div className={'col-5'}>
                                                <Button color="secondary" className={'mt-4 custom-btn4'} size={'md'}
                                                        disabled={!isLoading}
                                                        onClick={(e) => {
                                                            setCodeInput(false)
                                                            setCodeInputMobile(false)
                                                            setTimer(110);
                                                            setIsActive(false);
                                                            // window.location.reload()
                                                        }} block>

                                                    {type == 'mobile' ? 'change mobile' : 'change email'}

                                                </Button>
                                            </div>
                                        </div>
                                    </>

                                    :
                                    <Button className={'custom-btn1'} size={'lg'}
                                            disabled={(type === 'mobile' && phone === '') || (type === 'email' && email === '') || showAlert || !isLoading}
                                            onClick={(e) => {
                                                setIsLoading(false)
                                                sendOtp(e)
                                            }} block>
                                        Send

                                    </Button>
                                }


                                {!isLoading &&
                                    <Dimmer active>
                                        <Loader content='Loading'/>
                                    </Dimmer>}
                            </div>
                            {/*<div className={'col-10 col-md-7 text-center mt-4 link-border'}>*/}
                            {/*    <Link to={'/register'}>هنوز ثبت نام نکرده ایید ؟ ثبت نام</Link>*/}
                            {/*</div>*/}
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default LoginEn;